export const GEO_REQUIRED_MESSAGE =
  "Location access is mandatory to apply for a loan. Please allow location permission and try again.";

const GEO_SESSION_KEY = "applicant_geo";
let pendingGeo = null;

/**
 * One location capture per browser session, shared by parallel requests.
 * Resolves { ok: true, lat, long } or { ok: false, error }.
 */
export function captureApplicantGeolocation() {
  try {
    const cached = sessionStorage.getItem(GEO_SESSION_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed?.lat && parsed?.long) {
        return Promise.resolve({ ok: true, lat: String(parsed.lat), long: String(parsed.long) });
      }
    }
  } catch (e) {
    // Ignore unreadable session cache and ask the browser again.
  }

  if (!pendingGeo) {
    pendingGeo = getApplicantGeolocation()
      .then((geo) => {
        if (geo.ok) {
          try {
            sessionStorage.setItem(GEO_SESSION_KEY, JSON.stringify({ lat: geo.lat, long: geo.long }));
          } catch (e) {
            // Session storage can be unavailable; the request still carries the coordinates.
          }
        }
        return geo;
      })
      .finally(() => {
        pendingGeo = null;
      });
  }

  return pendingGeo;
}

export function getApplicantGeolocation(timeoutMs = 12000) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve({ ok: false, error: GEO_REQUIRED_MESSAGE });
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: timeoutMs,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position?.coords?.latitude;
        const long = position?.coords?.longitude;
        if (lat == null || long == null || Number.isNaN(Number(lat)) || Number.isNaN(Number(long))) {
          resolve({ ok: false, error: GEO_REQUIRED_MESSAGE });
          return;
        }
        resolve({ ok: true, lat: String(lat), long: String(long) });
      },
      () => resolve({ ok: false, error: GEO_REQUIRED_MESSAGE }),
      options
    );
  });
}
